export type BerthReservationStatusVo = 'required' | 'not_required' | 'unknown';

export const BerthReservationStatusLabels: Record<BerthReservationStatusVo, string> = {
  required: '要',
  not_required: '不要',
  unknown: '未確認',
};

export const BerthReservationStatusOptions: BerthReservationStatusVo[] = [
  'required',
  'not_required',
  'unknown'
];
